import { validateRequired } from 'simple-valley'
import yearValidator from './yearValidator.js'
import monthValidator from './monthValidator.js'
import dayValidator from './dayValidator.js'

export default function ugcDateValidator(v) {
  v = validateRequired(v, 'year')
  v = validateRequired(v, 'month')
  v = validateRequired(v, 'day')

  v = yearValidator(v)
  v = monthValidator(v)
  v = dayValidator(v)

  return v
}